module.exports = __webpack_public_path__ + "img/03-dora&phil.d6259f1c.jpg";